// eslint-disable-next-line no-restricted-imports
import * as vue3Notification from '@kyvg/vue3-notification';

export const notify = (option: vue3Notification.NotificationsOptions) => {
  logger.log({ option }, 'NotificationBanner');
  vue3Notification.notify(option);
};
